import { ComponentState, CurrentState } from "../component-state";

/**
 * @deprecated Use the `ComponentState` instead.
 */
export type AppState = ComponentState;

/**
 * @deprecated Use the `CurrentState` instead.
 */
export type CurrentAppState = CurrentState;
